<template>
  <div class="profile">
    <router-link :to="{path: '/admin/settings/users/' + admin_user_id}" target="_blank" rel="noopener">
      <img :src="currentUser.logo || '/static/images/elements/man.png'" class="avatar"/>
    </router-link>

    <div class="info" @click="toggleDropdown" v-on-click-away="hideDropdown">
      <span class="username">{{ userFullName }}</span>
      <span class="company">{{ userCompanyName }}</span>
      <img src="/static/images/elements/caret-down.svg" alt="caret down">
    </div>

    <ul v-if="showDropdownMenu" class="dropdown">
      <template v-if="currentUser.position">
        <li class="user-position">
          {{ currentUser.position }}
        </li>
        <li role="separator" class="divider"></li>
      </template>

      <li>
        <router-link :to="{path: '/admin/settings/users/' + admin_user_id}" target="_blank" rel="noopener">
          {{ $tr('profile.title') }}
        </router-link>
      </li>

      <router-link tag="li" to="/logout">
        <a>{{ $tr('login.logout') }}</a>
      </router-link>

      <template v-if="helpExists">
        <router-link tag="li" to="/help">
          <a>{{ $tr('help.title') }}</a>
        </router-link>
      </template>
    </ul>
  </div>
</template>

<script>
  import { directive as VueClickAway } from 'vue-clickaway'
  import { STORE_PREFIX } from './constants.js';
  import { mapGetters } from 'vuex';
  import store from './stores.js';

  export default {
    name: 'profile-info',

    mixins: [store],

    directives: {
      onClickAway: VueClickAway
    },

    data () {
      return {
        showDropdownMenu: false
      }
    },

    methods: {
      toggleDropdown () {
        this.showDropdownMenu = !this.showDropdownMenu
      },

      hideDropdown () {
        this.showDropdownMenu = false
      },

      fetch_admin_user () {
        this.$store.dispatch(STORE_PREFIX + 'admin/user/fetch_current_admin_user')
      }
    },

    computed: {
      ...mapGetters(STORE_PREFIX + 'admin', {
        admin_user: 'user/get_current_admin_user'
      }),

      admin_user_id() {
        if (!this.admin_user || !this.admin_user.id) {
          return ''
        }

        return this.admin_user.id;
      },

      currentUser () {
        return this.$store.getters['user/current'] || {}
      },

      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },

      userFullName () {
        if (!this.currentUser) {
          return '';
        }
        return !this.is_japan_locale ? this.currentUser.full_name : this.currentUser.full_name_reverse;
      },

      userCompanyName () {
        const userCompany = this.currentUser ? this.currentUser.company : null

        return userCompany ? userCompany.name : ''
      },

      helpExists () {
        return !!this.$store.state.managers.data
      }
    },

    beforeMount () {
      this.fetch_admin_user();
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

  .profile {
    height: 100%;
    min-width: 200px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    .avatar {
      width: 33px;
      height: 33px;
      flex: 0 0 33px;
      border-radius: 50%;
      margin-right: 13px;
    }

    .info {
      height: 100%;
      width: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      font-size: 1em;
      position: relative;
      padding-right: 17px;
      cursor: pointer;

      .username {
        font-weight: 600;
        color: $green;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .company {
        font-size: 0.80em;
        margin-top: 1px;
        color: $grey-color;
        width: 100%;
        box-sizing: border-box;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      img {
        cursor: pointer;
        width: 8px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
      }
    }

    ul {
      width: 250px;
      display: block;
      position: absolute;
      background: #fff;
      top: 110%;
      right: 0;
      list-style-type: none;
      padding: 6px 0;

      li {
        margin: 8px 21px;
        line-height: 1.6em;

        &.user-position {
          margin: 16px 21px;
        }

        &.divider {
          height: 1px;
          padding: 0;
          margin: 16px 0;
          background-color: #cccccc;
        }

        a {
          text-decoration: none;
          display: block;
        }

        a:hover {
          color: $green-hover;
        }
      }
    }
  }
</style>
